import { render, staticRenderFns } from "./BarDomChart.vue?vue&type=template&id=99d3f0e2&scoped=true&"
import script from "./BarDomChart.vue?vue&type=script&lang=js&"
export * from "./BarDomChart.vue?vue&type=script&lang=js&"
import style0 from "./BarDomChart.vue?vue&type=style&index=0&id=99d3f0e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d3f0e2",
  null
  
)

export default component.exports